import { mainApi } from "../../../../api";

export const userSavedCardsQuery = () => ({
    queryKey: ["userSavedCards"],
    queryFn: async () => mainApi.get("user_saved_cards"),
});
